/**
 * @typedef {Object} TileLayerCacheStrategyOptions
 * @property {boolean} openlayers This layer tile must be cached by openlayers
 * @property {boolean} serviceWorker This layer tile must be cached by the service worker
 */
// import TileSource from 'ol/source/Tile';
import TileCache from 'ol/TileCache';

export class TileLayerCacheStrategy {
  /**
     * @constructor
     * @param {TileLayerCacheStrategyOptions} options Cache options.
     */
  constructor(options) {
    this.useServiceWorkerCache = !(options && options.serviceWorker === false);
    this.useOpenLayersCache = !(options && options.openlayers === false);
  }

  /**
     * Run the cache strategy following the parameters initialized
     * @param {TileSource} tileSource The source that must be cached
     */
  run(tileSource) {
    // Prevents tile layer to be cached by the service worker
    if (!this.useServiceWorkerCache) {
      this.preventServiceWorkerCaching(tileSource);
    }

    // Force the tile to be refresh even being cached
    if (!this.useOpenLayersCache) {
      this.clearOLCache(tileSource);
    }
  }

  /**
     * Trigger the layer to refresh its cache
     * @param {TileSource} tileSource
     */
  // eslint-disable-next-line class-methods-use-this
  clearOLCache(tileSource) {
    if ('tileCache' in tileSource && tileSource.tileCache instanceof TileCache) {
      tileSource.tileCache.expireCache({});
      tileSource.tileCache.clear();
      tileSource.refresh();
    }
  }

  /**
     * Add a parameter to the tile request which avoid the tile image to be cached
     * by the ServiceWorker
     * @param {TileSource} tileSource
     */
  // eslint-disable-next-line class-methods-use-this
  preventServiceWorkerCaching(tileSource) {
    if ('updateParams' in tileSource && typeof tileSource.updateParams === 'function') {
      tileSource.updateParams({ ts: new Date().getTime() });
    }
  }
}
